var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0619 0.00150853C13.5397 0.0878989 10.5141 0.402349 8.64626 1.5457C8.51737 1.62459 8.44431 1.76487 8.44431 1.91154V12.0192C8.44431 12.3401 8.79515 12.5428 9.09099 12.3939C11.0127 11.4267 13.7919 11.1628 15.1661 11.0906C15.6353 11.0659 16 10.6897 16 10.2389V0.854301C16.0003 0.362348 15.5736 -0.0273809 15.0619 0.00150853ZM7.35374 1.5457C5.48621 0.402349 2.4606 0.0881767 0.93835 0.00150853C0.426674 -0.0273809 0 0.362348 0 0.854301V10.2392C0 10.6903 0.364729 11.0664 0.833903 11.0909C2.20865 11.1631 4.98925 11.4273 6.91095 12.3951C7.20596 12.5437 7.55569 12.3412 7.55569 12.0212V1.90654C7.55569 1.75959 7.48291 1.62487 7.35374 1.5457Z",
    fill: "current"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.a1228a7c.svg";
export { ForwardRef as ReactComponent };